export const PRELOAD_URL_PARAM = 'preload'

export const BRAZE_PROMO_CODE_CONSOLIDATION = {
  'Promo Code Rejected': [
    'Promo Code Automatically Loading Failed',
    'Invalid Promo Code Attempted',
    'Could Not Add Promo Code',
    'Invalid Promo Code',
  ],
  'Promo Code Updated': ['Change Promo Code Tapped', 'Promo Code Changed'],
  'Promo Code Removed': ['Remove Promo Code Tapped', 'Promo Code Removed'],
}

// Internal storage keys
export const LAST_ATTRIBUTION_PARAMS_TIME_KEY = 'LastAttributionParamsTime'
export const LOCAL_STORAGE_KEY = 'analytics'
export const USER_PHONE_NUMBER_KEY = 'userPhoneNumber'
export const USER_COUNTRY_CODE_KEY = 'User Country Code'
